import {
  FormControl,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  useTheme,
} from "@mui/material";
import React from "react";
import AppLabelComponent from "../../../AppComponents/AppLabelComponent";

export const InvestmentInput = React.memo(
  ({ isOnboardClientInvestment, currency = "INR", minInvestment, onChange, touched, errors, disabled }) => {
    const theme = useTheme();
    const investmentPlaceholder = (currency) =>
      currency === "INR" ? "00,00,000" : "00,000";
    return (
      <AppLabelComponent label={isOnboardClientInvestment ? "" : "Minimum Investment"}>
        <FormControl fullWidth size="small" variant="outlined">
          <OutlinedInput
            startAdornment={
              <InputAdornment position="start">
                <Select
                  name="currency"
                  value={currency}
                  onChange={onChange}
                  variant="standard"
                  disableUnderline
                  disabled={disabled}
                  sx={{
                    minWidth: 60,
                    fontWeight: theme.typography.fontWeightMedium,
                    "& .MuiSelect-select": { p: 0, pl: 1, pr: 2 },
                  }}
                  inputProps={{ "aria-label": "Currency" }}
                >
                  <MenuItem value="INR">INR ₹</MenuItem>
                  <MenuItem value="USD">USD $</MenuItem>
                </Select>
              </InputAdornment>
            }
            placeholder={investmentPlaceholder(currency)}
            name="minInvestment"
            value={minInvestment}
            onChange={onChange}
            error={touched && !!errors}
            sx={{ pl: 0 }}
            inputProps={{ "aria-label": "Minimum Investment" }}
            disabled={disabled}
          />
          {touched && errors && (
            <span style={{ color: theme.palette.error.main, fontSize: 12 }}>
              {errors}
            </span>
          )}
        </FormControl>
      </AppLabelComponent>
    );
  }
);
